import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';

@Component({
  selector: 'app-trading-system-summary',
  standalone: true,
  templateUrl: './trading-system-summary.component.html',
  styleUrls: ['./trading-system-summary.component.scss'],
  imports: [CommonModule]
})
export class TradingSystemSummaryComponent implements OnInit {

  @Input() ts: TradingSystemSummary 
  constructor() { 
    this.ts = new TradingSystemSummary()
  }

  ngOnInit(): void {
  }

}
